const contactForm = {"formFields":[{"step":[{"group":[[{"field":[{"htmlFor":"question","type":"textarea","description":"Pytanie","id":"question","name":"Pytanie","value":"","placeholder":"Wpisz pytanie","pattern":"","minLength":"","maxLength":"","required":false,"elementSize":1}]}]],"groupName":"Napisz wiadomość do Nas, a my skontaktujemy się z Tobą jak najszybciej","groupSize":2}],"stepName":"Formularz kontaktowy","stepNumber":1},{"step":[{"group":[[{"field":[{"htmlFor":"first_name","type":"text","description":"Imię","id":"first_name","name":"Imię","value":"","placeholder":"Wpisz imię","pattern":"^[A-Z]+","minLength":"","maxLength":"","required":true,"elementSize":2}]},{"field":[{"htmlFor":"last_name","type":"text","description":"Nazwisko","id":"last_name","name":"Nazwisko","value":"","placeholder":"Wpisz nazwisko","pattern":"^[A-Z]+","minLength":"","maxLength":"","required":true,"elementSize":2}]}]],"groupName":"Dane do kontaktu","groupSize":4},{"group":[[{"field":[{"htmlFor":"phone","type":"number","description":"Telefon","id":"phone","name":"Telefon","value":"","placeholder":"Wpisz telefon","pattern":"","minLength":"","maxLength":"","required":false,"elementSize":2}]},{"field":[{"htmlFor":"email","type":"text","description":"Email","id":"email","name":"Email","value":"","placeholder":"Wpisz email","pattern":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$","minLength":"","maxLength":"","required":false,"elementSize":2}]}]],"groupName":"","groupSize":4},{"group":[[{"field":[{"htmlFor":"marketing","type":"checkbox","description":"Wyrażam zgodę na przetwarzanie moich danych w celach marketingowych przez Motortest Anna Szadkowska. Zgoda jest dobrowolna i może zostać w każdej chwili wycofana","id":"marketing","name":"Zgoda Marketingowa","value":true,"placeholder":"Potwierdź zgodę","pattern":"","minLength":"","maxLength":"","required":false,"elementSize":1}]}]],"groupName":"Zgody","groupSize":1}],"stepName":"Formularz kontaktowy","stepNumber":2}]}

const insuranceForm = {"formFields":[{"step":[{"group":[[{"field":[{"htmlFor":"vin","type":"text","description":"VIN pojazdu","id":"vin","name":"VIN","value":"","placeholder":"wpisz VIN","pattern":"","minLength":"","maxLength":"","required":"","elementSize":1}]},{"field":[{"htmlFor":"registration_number","type":"text","description":"Numer rejestracyjny pojazdu","id":"registration_number","name":"Numer rejestracyjny","value":"","placeholder":"wpisz Numer Rejestracyjny","pattern":"","minLength":"","maxLength":"","required":"","elementSize":1}]},{"field":[{"htmlFor":"registration_date","type":"date","description":"Podaj datę pierwszej rejestracji","id":"registration_date","name":"Data rejestracji","value":"","placeholder":"Podaj datę pierwszej rejestracji","pattern":"","minLength":"2010-01-01","maxLength":"","required":"","elementSize":1}]}]],"groupName":"Dane pojazdu","groupSize":3}],"stepName":"Zapytaj o ofertę ubezpieczenia: nowego jak i wznowienia.","stepNumber":1},{"step":[{"group":[[{"field":[{"htmlFor":"first_name","type":"text","description":"Imię","id":"first_name","name":"Imię","value":"","placeholder":"Wpisz imię","pattern":"^[A-Z]+","minLength":"","maxLength":"","required":true,"elementSize":2}]},{"field":[{"htmlFor":"last_name","type":"text","description":"Nazwisko","id":"last_name","name":"Nazwisko","value":"","placeholder":"Wpisz nazwisko","pattern":"^[A-Z]+","minLength":"","maxLength":"","required":true,"elementSize":2}]}]],"groupName":"Dane do kontaktu","groupSize":4},{"group":[[{"field":[{"htmlFor":"phone","type":"number","description":"Telefon","id":"phone","name":"Telefon","value":"","placeholder":"Wpisz telefon","pattern":"","minLength":"","maxLength":"","required":false,"elementSize":2}]},{"field":[{"htmlFor":"email","type":"text","description":"Email","id":"email","name":"Email","value":"","placeholder":"Wpisz email","pattern":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$","minLength":"","maxLength":"","required":false,"elementSize":2}]}]],"groupName":"","groupSize":4},{"group":[[{"field":[{"htmlFor":"marketing","type":"checkbox","description":"Wyrażam zgodę na przetwarzanie moich danych w celach marketingowych przez Motortest Anna Szadkowska. Zgoda jest dobrowolna i może zostać w każdej chwili wycofana","id":"marketing","name":"Zgoda Marketingowa","value":true,"placeholder":"Potwierdź zgodę","pattern":"","minLength":"","maxLength":"","required":false,"elementSize":1}]}]],"groupName":"Zgody","groupSize":1}],"stepName":"Formularz kontaktowy","stepNumber":2}]};

const serviceForm = {
  "formFields": [
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "name",
                    "type": "text",
                    "description": "Imię i Nazwisko",
                    "id": "name",
                    "name": "Imię i Naziwsko",
                    "value": "",
                    "placeholder": "Wpisz imię i nazwisko",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "phone",
                    "type": "number",
                    "description": "Telefon",
                    "id": "phone",
                    "name": "Telefon",
                    "value": "",
                    "placeholder": "Wpisz telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "email",
                    "type": "text",
                    "description": "Email",
                    "id": "email",
                    "name": "Email",
                    "value": "",
                    "placeholder": "Wpisz email",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 3
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "vin",
                    "type": "text",
                    "description": "VIN",
                    "id": "vin",
                    "name": "VIN",
                    "value": "",
                    "placeholder": "Wpisz VIN",
                    "pattern": "",
                    "minLength": "17",
                    "maxLength": "17",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "registration_number",
                    "type": "text",
                    "description": "Numer Rejestracyjny",
                    "id": "registration_number",
                    "name": "Numer Rejestracyjny",
                    "value": "",
                    "placeholder": "Wpisz numer rejestracyjny pojazdu",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "10",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 2
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "date",
                    "type": "date",
                    "description": "",
                    "id": "date",
                    "name": "Data Serwisu",
                    "value": "",
                    "placeholder": "Wybierz oczekiwaną datę serwisu",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "hour",
                    "type": "radio",
                    "description": "",
                    "id": "hour",
                    "name": "Godzina",
                    "value": "",
                    "placeholder": "Wybierz oczekiwaną godzinę serwisu",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 2,
                    "options": [
                      {
                        "value": "7",
                        "label": "7:30"
                      },
                      {
                        "value": "7",
                        "label": "7:45"
                      },
                      {
                        "value": "8",
                        "label": "8:00"
                      },
                      {
                        "value": "9",
                        "label": "9:00"
                      },
                      {
                        "value": "10",
                        "label": "10:00"
                      },
                      {
                        "value": "11",
                        "label": "11:00"
                      },
                      {
                        "value": "12",
                        "label": "12:00"
                      },
                      {
                        "value": "13",
                        "label": "13:00"
                      },
                      {
                        "value": "14",
                        "label": "14:00"
                      },
                      {
                        "value": "15",
                        "label": "15:00"
                      },
                      {
                        "value": "16",
                        "label": "16:00"
                      }
                    ]
                  }
                ]
              }
            ]
          ],
          "groupName": "Wybierz datę i godzinę serwisu swojego pojazdu",
          "groupSize": 3
        }
      ],
      "stepName": "Jeżeli Twój samochód już był u nas na serwisie, nie musisz podawać VINu.",
      "stepNumber": 1
    },
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "marketing",
                    "type": "checkbox",
                    "description": "Wyrażam zgodę na przetwarzanie moich danych osobowych przez Motortest Anna Szadkowska z siedzibą w Warszawie, przy ul. Franciszka Hynka 2A, oraz przez Hyundai Motor Poland Sp. z o.o. z siedzibą w Warszawie, przy ul. Wołoska 24, w zakresie Imię , Nazwisko , dane teleadresowe , adres email do celów marketingowych. Oświadczam iż moja zgoda jest dobrowolna i może być w każdej chwili wycofana.",
                    "id": "marketing",
                    "name": "Zgoda marketingowa",
                    "value": true,
                    "placeholder": "Potwierdź zgodę",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 1
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "marketing_phone",
                    "type": "checkbox",
                    "description": "Telefon",
                    "id": "marketing_phone",
                    "name": "Telefon",
                    "value": true,
                    "placeholder": "Potwierdź zgodę telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "marketing_sms",
                    "type": "checkbox",
                    "description": "SMS",
                    "id": "marketing_sms",
                    "name": "SMS",
                    "value": true,
                    "placeholder": "Potwierdź zgodę sms",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "marketing_email",
                    "type": "checkbox",
                    "description": "Email",
                    "id": "marketing_email",
                    "name": "Email",
                    "value": true,
                    "placeholder": "Potwierdź zgodę email",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "W jaki sposób mamy się kontaktować z Tobą",
          "groupSize": 3
        }
      ],
      "stepName": "Zgody na przyszły marketing (OPCJONALNE)",
      "stepNumber": 2
    }
  ]
}

const buybackForm = {
  "formFields": [
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "brand",
                    "type": "enum",
                    "description": "Wybierz markę",
                    "id": "brand",
                    "name": "Marka",
                    "value": "",
                    "placeholder": "Wybierz markę",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "model",
                    "type": "enum",
                    "description": "Wybierz model",
                    "id": "model",
                    "name": "Marka",
                    "value": "",
                    "placeholder": "Wybierz model",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "production_year",
                    "type": "number",
                    "description": "Rok produkcji",
                    "id": "production_year",
                    "name": "Rok produkcji",
                    "value": "",
                    "placeholder": "Podaj rok produkcji pojazdu",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "mileage",
                    "type": "number",
                    "description": "Przebieg pojazdu",
                    "id": "mileage",
                    "name": "Przebieg",
                    "value": "",
                    "placeholder": "Podaj aktualny przebieg pojazdu",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "engine_size",
                    "type": "number",
                    "description": "Pojemność silnika",
                    "id": "engine_size",
                    "name": "Pojemność silnika",
                    "value": "",
                    "placeholder": "np. 1000",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "engine_power",
                    "type": "number",
                    "description": "Moc silnika (Km)",
                    "id": "engine_power",
                    "name": "Moc silnika (Km)",
                    "value": "",
                    "placeholder": "np. 120",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "vin",
                    "type": "text",
                    "description": "VIN pojazdu",
                    "id": "vin",
                    "name": "VIN",
                    "value": "",
                    "placeholder": "Podaj VIN",
                    "pattern": "",
                    "minLength": "17",
                    "maxLength": "17",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "link",
                    "type": "text",
                    "description": "Link do ogłoszenia",
                    "id": "link",
                    "name": "Link do ogłoszenia",
                    "value": "",
                    "placeholder": "Link do ogłoszenia",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "color",
                    "type": "enum",
                    "description": "Kolor nadwozia",
                    "id": "color",
                    "name": "Kolor nadwozia",
                    "value": "",
                    "placeholder": "wpisz kolor nadwozia",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Podaj informacje o swoim samochodzie. Im więcej podasz, tym precyzyjniej przedstawimy Tobie wstępną wycenę auta.",
          "groupSize": 3
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "powertrain",
                    "type": "radio",
                    "description": "Wybierz napęd",
                    "id": "powertrain",
                    "name": "Napęd",
                    "value": "",
                    "placeholder": "wybierz napęd",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": [
                      {
                        "value": "Przednia oś",
                        "label": "Przednia oś"
                      },
                      {
                        "value": "Tylna oś",
                        "label": "Tylna oś"
                      },
                      {
                        "value": "Obie osie",
                        "label": "Obie osie"
                      }
                    ]
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "fuel",
                    "type": "radio",
                    "description": "Paliwo",
                    "id": "fuel",
                    "name": "Paliwo",
                    "value": "",
                    "placeholder": "Paliwo",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": [
                      {
                        "value": "Benzyna",
                        "label": "Benzyna"
                      },
                      {
                        "value": "Benzyna + Gaz",
                        "label": "Benzyna + Gaz"
                      },
                      {
                        "value": "Diesel",
                        "label": "Diesel"
                      },
                      {
                        "value": "Hybryda",
                        "label": "Hybryda"
                      },
                      {
                        "value": "Hybryda Plug-in",
                        "label": "Hybryda Plug-in"
                      },
                      {
                        "value": "Elektryczny",
                        "label": "Elektryczny"
                      }
                    ]
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "body",
                    "type": "radio",
                    "description": "Rodzaj nadwozia",
                    "id": "body",
                    "name": "Rodzaj nadwozia",
                    "value": "",
                    "placeholder": "Rodzaj nadwozia",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": [
                      {
                        "value": "Hatchback",
                        "label": "Hatchback"
                      },
                      {
                        "value": "Kombi",
                        "label": "Kombi"
                      },
                      {
                        "value": "SUV",
                        "label": "SUV"
                      },
                      {
                        "value": "Sedan",
                        "label": "Sedan"
                      },
                      {
                        "value": "Liftback",
                        "label": "Liftback"
                      },
                      {
                        "value": "VAN",
                        "label": "VAN"
                      }
                    ]
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "transmission",
                    "type": "radio",
                    "description": "Skrzynia biegów",
                    "id": "transmission",
                    "name": "Skrzynia biegów",
                    "value": "",
                    "placeholder": "Skrzynia biegów",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": [
                      {
                        "value": "Manualna",
                        "label": "Manualna"
                      },
                      {
                        "value": "Automatyczna",
                        "label": "Automatyczna"
                      }
                    ]
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "sales_type",
                    "type": "radio",
                    "description": "Rodzaj sprzedaży",
                    "id": "sales_type",
                    "name": "Rodzaj sprzedaży",
                    "value": "",
                    "placeholder": "Rodzaj sprzedaży",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": [
                      {
                        "value": "Osoba prywatna",
                        "label": "Osoba prywatna"
                      },
                      {
                        "value": "Faktura VAT 23%",
                        "label": "Faktura VAT 23%"
                      },
                      {
                        "value": "Inna",
                        "label": "Inna"
                      }
                    ]
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 1
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "accidents",
                    "type": "checkbox",
                    "description": "Bezwypadkowy",
                    "id": "accidents",
                    "name": "Bezwypadkowy",
                    "value": "",
                    "placeholder": "Bezwypadkowy",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "country",
                    "type": "checkbox",
                    "description": "Kupiony w Polsce",
                    "id": "country",
                    "name": "Kupiony w Polsce",
                    "value": "",
                    "placeholder": "Kupiony w Polsce",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "service_aso",
                    "type": "checkbox",
                    "description": "Serwis w ASO",
                    "id": "service_aso",
                    "name": "Serwis w ASO",
                    "value": "",
                    "placeholder": "Serwis w ASO",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "first_owner",
                    "type": "checkbox",
                    "description": "Pierwszy właściciel",
                    "id": "first_owner",
                    "name": "Pierwszy właściciel",
                    "value": "",
                    "placeholder": "Pierwszy właściciel",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Informacje dodatkowe",
          "groupSize": 4
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "images",
                    "type": "image",
                    "description": "Zdjęcia auta",
                    "id": "images",
                    "name": "Zdjęcia auta",
                    "value": "",
                    "placeholder": "Zdjęcia auta",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Zdjęcia pojazdu",
          "groupSize": 1
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "expectations",
                    "type": "textarea",
                    "description": "Wpisz ile chciałbyś otrzymać za samochód",
                    "id": "expectations",
                    "name": "Oczekiwania finansowe",
                    "value": "",
                    "placeholder": "Oczekiwania finansowe",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": "",
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Oczekiwania finansowe",
          "groupSize": 1
        }
      ],
      "stepName": "Dane pojazdu",
      "stepNumber": 1
    },
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "first_name",
                    "type": "text",
                    "description": "Imię",
                    "id": "first_name",
                    "name": "Imię",
                    "value": "",
                    "placeholder": "Wpisz imię",
                    "pattern": "^[A-Z]+",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "last_name",
                    "type": "text",
                    "description": "Nazwisko",
                    "id": "last_name",
                    "name": "Nazwisko",
                    "value": "",
                    "placeholder": "Wpisz nazwisko",
                    "pattern": "^[A-Z]+",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Dane do kontaktu",
          "groupSize": 2
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "phone",
                    "type": "number",
                    "description": "Telefon",
                    "id": "phone",
                    "name": "Telefon",
                    "value": "",
                    "placeholder": "Wpisz telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "email",
                    "type": "text",
                    "description": "Email",
                    "id": "email",
                    "name": "Email",
                    "value": "",
                    "placeholder": "Wpisz email",
                    "pattern": "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Dane do kontaktu",
          "groupSize": 2
        },
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "marketing",
                    "type": "checkbox",
                    "description": "Wyrażam zgodę na przetwarzanie moich danych w celach marketingowych przez Motortest Anna Szadkowska. Zgoda jest dobrowolna i może zostać w każdej chwili wycofana",
                    "id": "marketing",
                    "name": "Zgoda Marketingowa",
                    "value": true,
                    "placeholder": "Potwierdź zgodę",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "marketing",
                    "type": "checkbox",
                    "description": "Wyrażam zgodę na przetwarzanie moich danych w celach marketingowych przez telefon",
                    "id": "marketing_phone",
                    "name": "Zgoda Marketingowa",
                    "value": true,
                    "placeholder": "Potwierdź zgodę telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "Dane do kontaktu",
          "groupSize": 1
        }
      ],
      "stepName": "Formularz kontaktowy",
      "stepNumber": 2
    }
  ]
}

const tucsonForm = {
  "formFields": [
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "name",
                    "type": "text",
                    "description": "Imię i Nazwisko",
                    "id": "name",
                    "name": "Imię i Naziwsko",
                    "value": "",
                    "placeholder": "Wpisz imię i nazwisko",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "phone",
                    "type": "number",
                    "description": "Telefon",
                    "id": "phone",
                    "name": "Telefon",
                    "value": "",
                    "placeholder": "Wpisz telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "email",
                    "type": "text",
                    "description": "Email",
                    "id": "email",
                    "name": "Email",
                    "value": "",
                    "placeholder": "Wpisz email",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 1
        }
      ],
      "stepName": "Dowiedz się więcej",
      "stepNumber": 1
    }
  ]
}

const stariaForm = {
  "formFields": [
    {
      "step": [
        {
          "group": [
            [
              {
                "field": [
                  {
                    "htmlFor": "name",
                    "type": "text",
                    "description": "Imię i Nazwisko",
                    "id": "name",
                    "name": "Imię i Naziwsko",
                    "value": "",
                    "placeholder": "Wpisz imię i nazwisko",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": true,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "phone",
                    "type": "number",
                    "description": "Telefon",
                    "id": "phone",
                    "name": "Telefon",
                    "value": "",
                    "placeholder": "Wpisz telefon",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              },
              {
                "field": [
                  {
                    "htmlFor": "email",
                    "type": "text",
                    "description": "Email",
                    "id": "email",
                    "name": "Email",
                    "value": "",
                    "placeholder": "Wpisz email",
                    "pattern": "",
                    "minLength": "",
                    "maxLength": "",
                    "required": false,
                    "elementSize": 1,
                    "options": []
                  }
                ]
              }
            ]
          ],
          "groupName": "",
          "groupSize": 1
        }
      ],
      "stepName": "Dowiedz się więcej",
      "stepNumber": 1
    }
  ]
}

export {contactForm, insuranceForm, serviceForm, buybackForm, tucsonForm, stariaForm};


// Param: {htmlFor, type, description, id, name, value, placeholder}